


/**
* Close Out Types within GuideStream
*/
export enum CloseOutType{
    /**
    * Complete. Used when the mentor presses Finish and Sync in a session.
    */
    Complete = 0,
    /**
    * Partial Close Out.
    */
    Partial = 1,
    /**
    * Cancellation. Used when the mentor presses Cancel GuideStream in a session or the cancellation API endpoint is called.
    */
    Cancellation = 2
}

